import { z } from '@hono/zod-openapi'
import { zSelectBenefitClaim } from './benefit-claim.zod'

export const zClaimWithBenefitDetails = zSelectBenefitClaim.extend({
    benefitTitle: z.string().nullable().optional(),
    benefitDescription: z.string().nullable().optional(),
    vendorName: z.string().nullable().optional(),
    vendorLogoUrl: z.string().nullable().optional(),
    categoryName: z.string().nullable().optional(),
    employeeFirstName: z.string().nullable().optional(),
    employeeLastName: z.string().nullable().optional(),
    employeeEmail: z.string().nullable().optional(),
    clientName: z.string().nullable().optional(),
})

export const zClaimBenefitRequest = z.object({
    benefitId: z.string().min(1).openapi({
        description: 'ID of the benefit to claim',
        example: 'bnf_12345',
    }),
    notes: z.string().optional().openapi({
        description: 'Optional notes for this claim',
    }),
})

export const zRedeemClaimRequest = z.object({
    claimCode: z.string().min(1).openapi({
        description: 'Unique claim code to redeem',
        example: 'CLM-ABC123XYZ',
    }),
})

export const zRedeemClaimResponse = z.object({
    id: z.string(),
    claimCode: z.string(),
    status: z.string(),
    redeemedAt: z.string().nullable(),
    benefitTitle: z.string().nullable().optional(),
    vendorName: z.string().nullable().optional(),
    employeeName: z.string().nullable().optional(),
})

export type ClaimWithBenefitDetails = z.infer<typeof zClaimWithBenefitDetails>
export type ClaimBenefitRequest = z.infer<typeof zClaimBenefitRequest>
export type RedeemClaimRequest = z.infer<typeof zRedeemClaimRequest>
export type RedeemClaimResponse = z.infer<typeof zRedeemClaimResponse>
